module.exports = __webpack_public_path__ + "img/sq-4.f98a5fb4.jpg";